import { defineMessages } from 'react-intl';

export default defineMessages({
    NamedItems: {
        id: 'quoteandbind.ngh.views.itemsOutsideCard.NamedItems',
        defaultMessage: 'Named Items - Other'
    },
    valuablesCtaDescription: {
        id: 'quoteandbind.ngh.views.itemsOutsideCard.valuablesCtaDescription',
        defaultMessage: 'If you plan on taking any items away from the home that are individually worth more than '
    },
    valuablesCtaDescription1: {
        id: 'quoteandbind.ngh.views.itemsOutsideCard.valuablesCtaDescription1',
        defaultMessage: ' that are not in the list of what we consider to be valuables, so that they are covered you need to add them to your policy.'
    }

});
